// extracted by mini-css-extract-plugin
module.exports = {"container":"prose_container__3dJlM"};